import React from "react";
import { Button, ButtonProps } from "@mui/material";

interface FormButtonProps extends ButtonProps {
  isSelected?: boolean;
}

const FormButton: React.FC<FormButtonProps> = ({
  children,
  isSelected = false,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        justifyContent: "center",
        borderColor: isSelected ? "#1976d2" : "#ccc",
        backgroundColor: isSelected
          ? "rgba(25, 118, 210, 0.04)"
          : "transparent",
        color: "#000",
        "&:hover": {
          borderColor: "#1976d2",
          bgcolor: "rgba(25, 118, 210, 0.04)",
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default FormButton;
